import React, { useEffect, useState } from 'react';
import CommonLayout from '../../layouts/CommonLayout';
import NotificationContainer from '../../containers/NotificationContainer';
import { getNotifications, deleteAllNotifications } from '../../../api/NotificationApi';
import useNotificationStore from '../../../store/notificationStore';
import { ConfirmModal } from '../../layouts/ConfirmModal';
import { AlertModal } from '../../layouts/AlertModal';

const NotificationPage = () => {
    const [notifications, setNotifications] = useState([]);
    const { clearUnreadStatus } = useNotificationStore();

    // 모달 상태 관리
    const [confirmState, setConfirmState] = useState({ isVisible: false, title: '', message: '', onConfirm: () => {} });
    const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

    // 헬퍼 함수
    const showConfirm = (title, message, onConfirmAction) => {
        setConfirmState({
            isVisible: true,
            title,
            message,
            onConfirm: () => {
                onConfirmAction();
                setConfirmState({ ...confirmState, isVisible: false });
            }
        });
    };

    const getErrorMessage = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        }
        return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
    };

    const fetchNotifications = async () => {
        try {
            const data = await getNotifications();
            setNotifications(data);
            clearUnreadStatus();
        } catch (error) {
            console.error('알림을 불러오는데 실패했습니다:', error);
            setAlertState({ isVisible: true, message: '알림을 불러오는 데 실패했습니다.' });
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const handleDelete = (id) => {
        setNotifications(notifications.filter(notification => notification.id !== id));
    };

    const handleDeleteAll = async () => {
        showConfirm('알림 전체 삭제', '모든 알림을 삭제하시겠습니까?', async () => {
            try {
                await deleteAllNotifications();
                setNotifications([]);
            } catch (error) {
                console.error('전체 알림 삭제에 실패했습니다:', error);
                setAlertState({ isVisible: true, message: getErrorMessage(error) });
            }
        });
    };

    return (
        <CommonLayout title="알림">
            <ConfirmModal
                isVisible={confirmState.isVisible}
                title={confirmState.title}
                message={confirmState.message}
                onConfirm={confirmState.onConfirm}
                onCancel={() => setConfirmState({ ...confirmState, isVisible: false })}
            />
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
            />
            <div className="flex flex-col gap-4 p-4">
                {notifications.length > 0 && (
                    <button
                        onClick={handleDeleteAll}
                        className="w-full py-2 px-4 bg-red-500 text-white rounded-lg active:bg-red-600 transition-colors"
                    >
                        전체 삭제
                    </button>
                )}

                <div className="flex flex-col gap-3">
                    {notifications.map((notification) => (
                        <NotificationContainer
                            key={notification.id}
                            notification={notification}
                            onDelete={handleDelete}
                        />
                    ))}

                    {notifications.length === 0 && (
                        <div className="text-center py-8 text-gray-500">
                            알림이 없습니다.
                        </div>
                    )}
                </div>
            </div>
        </CommonLayout>
    );
};

export default NotificationPage;
